import { GridCellProps } from "@progress/kendo-react-grid";
import { useAppSelector } from "../../redux/store";
import "./cell.css";
import { padZerosLeft } from "../../commons/helpers/StringHelper";
import { PTR_LENGTH } from "../../constants/products";

export default function PtrCell(props: GridCellProps) {
  let token = useAppSelector((state) => state.appState.token?.split(" ")[1]);
  let user = useAppSelector((state) => state.appState.user);
  const d_inv170 = useAppSelector((state) => state.appState.d_inv170);
  const ptr = padZerosLeft(props.dataItem[props.field!], PTR_LENGTH);

  return (
    <td
      colSpan={1}
      className="k-table-td"
      role="gridcell"
      aria-colindex={6}
      aria-selected="false"
      data-grid-col-index="5"
    >
      {d_inv170.canRead ? (
        <a
          href={`${process.env.REACT_APP_INVENTAIRE_URL}/#/Inventaire/Produit=${
            props.dataItem[props.field!]
          }?token=${token}&user=${user}`}
          className="k-cursor-pointer ptr-cell"
          target="_blank"
          rel="noreferrer"
        >
          {ptr}
        </a>
      ) : (
        <span>{ptr}</span>
      )}
    </td>
  );
}
